import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PolicyType } from "../types";

export const usePolicyTypes = () => {
  const queryClient = useQueryClient();

  const { data: policyTypes = [], ...rest } = useQuery({
    queryKey: ['policyTypes'],
    queryFn: async () => {
      console.log("Fetching policy types..."); 
      const { data, error } = await supabase
        .from('policy_types')
        .select('*')
        .order('sort_order', { ascending: true });

      if (error) {
        console.error('Error fetching policy types:', error);
        throw error;
      }

      console.log("Fetched policy types:", data);
      return data || [];
    },
    staleTime: 0, // Always fetch fresh data
    gcTime: 5 * 60 * 1000, // Cache for 5 minutes (renamed from cacheTime to gcTime)
  });

  const updatePolicyTypeOrder = async (items: PolicyType[]) => {
    try {
      for (let i = 0; i < items.length; i++) {
        const { error } = await supabase
          .from("policy_types")
          .update({ sort_order: i })
          .eq("id", items[i].id);

        if (error) throw error;
      }
      
      // Invalidate both queries after updating order
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['policyTypes'] }),
        queryClient.invalidateQueries({ queryKey: ['policyLines'] })
      ]);
      
      return { success: true };
    } catch (error) {
      console.error('Error updating policy type order:', error);
      return { success: false, error };
    }
  };

  return {
    policyTypes,
    updatePolicyTypeOrder,
    refetch: rest.refetch,
    ...rest
  };
};